<template>
  <div class="login">
    <div class="login-content">
      <Header class="mt-6" />
      <div class="card-animation-content">
        <transition :name="transitionName">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/ui/components/Header.vue';

export default {
  name: 'Login',
  components: { Header },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split('/').length;
    const fromDepth = from.path.split('/').length;
    this.transitionName = toDepth < fromDepth ? 'rotate-right' : 'rotate-left';
    next();
  },
  data() {
    return {
      transitionName: 'rotate-left'
    };
  }
};
</script>
<style lang="css" scoped>
  .login-content {
    width: 100%;
    min-height: 100vh;
    background-color: #4d4d4d0a;
    background-image: url(../../assets/img/burbujas-creditu.svg);
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: 40% auto;
    display: flex;
  }
  .card-animation-content{
    margin: auto;
    width: 37%;
    transition-duration: 0.25s;
    position: relative;
    transform-style: linear;
    margin-top: calc(0.378 * 100vh - 169.07px);
    -webkit-perspective: 900px;
    perspective: 900px;
  }

  .front-card, .back-card{
    -webkit-transition: 1s transform ease;
    -moz-transition: 1s transform ease;
    -ms-transition: 1s transform ease;
    -o-transition: 1s transform ease;
    transition: 1s transform ease;
  }

  .back-card{
    display: none;
  }

  /** Rotate left **/
  .rotate-left-enter-active {
    transform: rotateY(180deg);
  }
  .rotate-left-leave-active {
    transform: rotateY(0deg);
  }
  .rotate-left-enter-to{
    transform: rotateY(0deg);
  }
  .rotate-left-leave-to{
    transform: rotateY(-180deg);
    position: absolute;
    left: 0;
    z-index: 4;
  }
  .rotate-left-leave{
    position: absolute;
  }

  /** rotate right **/
  .rotate-right-enter-active {
    transform: rotateY(-180deg);
  }
  .rotate-right-leave-active {
    transform: rotateY(0deg);
  }
  .rotate-right-enter-to{
    transform: rotateY(0deg);
  }
  .rotate-right-leave-to{
    transform: rotateY(180deg);
    position: absolute;
    left: 0;
    z-index: 4;
  }
  .rotate-right-leave{
    position: absolute;
  }

    @media (max-height: 460px) {
      .card-animation-content{
        margin-top: 40px;
      }
    }
    @media (max-width: 980px) {
      .login-content .card-animation-content{
        width: 60%;
      }
    }
    @media (max-width: 768px) {
      .login-content .card-animation-content{
        width: 60%;
      }
    }
    @media (max-width: 640px) {
      .login-content .card-animation-content{
       width: 70%;
      }
    @media (max-width: 490px) {
      .login-content .card-animation-content{
       width: 90%;
      }
    }
    }
</style>
